import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController, App } from 'ionic-angular';
import { AppState } from '../../../app/app.global';




import { InAppBrowser,InAppBrowserOptions  } from '@ionic-native/in-app-browser';
import { HttpService } from '../../../providers/service/httpservice';
import { StorageService } from '../../../providers/service/storageservice';
import { THIRD_APP_JUMP, SELECT_SUBTYPES_URL, SELECT_MSGLIST_URL} from '../../../providers/config/serviceurl';
import {BrowserPage} from '../../comm/browser/browser';
@Component({
  selector: 'page-wddbmsglist',
  templateUrl: 'wddbmsglist.html',
})
/**我的待办消息页面 */
export class WddbmsglistPage {
  infiniteSscroll:any=null;//上拉控件
  overFlag:boolean = false;//数据全部加载完成标志
  msgList:any = [];//消息列表
  user:any={};
  categoryId:string;//消息分类ID
  code:any;//分类的code
  pageNo:number = 0;//分页页数
  pageSize:number = 10;
	public loading:any;
  callback;
  pageSlides:any[]=[];//头部滑动
  slideIndex:any = 0;

  constructor(public appCtrl: App,private loadCtrl:LoadingController ,public navCtrl: NavController, public navParams: NavParams,
     private httpService:HttpService,public global: AppState, private inAppBrowser:InAppBrowser) {
    this.user = StorageService.getObj('currentUser');
    this.categoryId = navParams.data.categoryId;
    this.code = navParams.data.code;
    this.callback = this.navParams.get("callback");
    this.getSubTypes();
  }

  //离开页面时触发
  ionViewWillLeave(){
    //返回消息列表
		let param = 'msgSettingListCache';
		this.callback(param).then(()=>{
		});
  }

  getSubTypes(){
    this.pageSlides=[];
    let params = {"username":this.user.xgh, "classifyId":this.categoryId};
    this.httpService.get2(SELECT_SUBTYPES_URL,params).then(anyObj =>this.handleSubtypes(anyObj));
  }

  handleSubtypes(obj:any){
		if(obj && obj.items ){
      let returnData = obj.items;
      for (let index = 0; index < returnData.length ; index++ ) {
        this.pageSlides.push({"name":returnData[index].NAME});
      }
      if(this.pageSlides && this.pageSlides.length > 0){
        this.onSlideClick(0);
      }
    }
  }

onSlideClick(index:any) {
  this.slideIndex = index;
    this.loading = this.loadCtrl.create({
       content: '加载中...',
    });
    this.loading.present();
    this.pageNo = 0;
    this.msgList=[];
    this.getMsgList(index);
}

getMsgList(index:any){
  if(this.pageSlides && this.pageSlides.length > 0){
    let params = {"username": this.user.xgh, "code":this.code, "typeName":this.pageSlides[index].name,"pageNo":this.pageNo, "pageSize":this.pageSize};
    this.httpService.get2(SELECT_MSGLIST_URL,params).then(anyObj =>this.handleMsgList(anyObj));
  }
}

handleMsgList(obj:any){
  if(obj && obj.items && obj.items.length > 0){
    let temp = obj.items;

    console.log(JSON.stringify(temp));

    for (let index = 0; index < temp.length ; index++ ) {
      // let str = temp[index].content;
        // let regex = /<a.*?>(.*?)<\/a>/ig; //取a标签里面的内容
        // let result ;
        // if((result= regex.exec(str))!=null){
        //   temp[index].content = result[1];
        //   alert(result[1]);
        // }
      
      // temp[index].content = temp[index].content.replace(/<a.*?>(.*?)<\/a>/ig, "");
      temp[index].content = temp[index].content.replace(/<a href[^>]*>/g, "");
      temp[index].content = temp[index].content.replace(/<\/a>/g, "");
      
    }

    this.msgList = this.msgList.concat(temp);
    this.overFlag = false;
    if(this.infiniteSscroll){
      this.infiniteSscroll.enable(true);
    }
    
  }else{
    this.overFlag = true;
    if(this.infiniteSscroll){
      this.infiniteSscroll.enable(false);
    }
  }
  if(this.loading){
    this.loading.dismiss();
  }
}

 gotoPage(item:any){
  
  if(item.mobileUrl){ 
    this.inAppBrowser.create(THIRD_APP_JUMP+"?hd="+this.user.hd+"&link="+this.urlencode(item.mobileUrl));    
    //this.appCtrl.getRootNav().push(BrowserPage,{browser: {title: item.title, url: THIRD_APP_JUMP+"?hd="+this.user.hd+"&link="+this.urlencode(item.mobileUrl) }});
  }else if(item.url){  
    this.inAppBrowser.create(THIRD_APP_JUMP+"?hd="+this.user.hd+"&link="+this.urlencode(item.url));
    //this.appCtrl.getRootNav().push(BrowserPage,{browser: {title: item.title, url: THIRD_APP_JUMP+"?hd="+this.user.hd+"&link="+this.urlencode(item.url)}});
  } 
 }

 urlencode (str) {  
  str = (str + '').toString();   
  return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').  
  replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');  
} 

//下拉刷新
doRefresh(refresher){
  this.onSlideClick(this.slideIndex);
  setTimeout(() => {
    refresher.complete();
  }, 1000);
}

//上拉加载更多
loadMore(refresher){
  if(this.infiniteSscroll == null){
    this.infiniteSscroll = refresher;
  }
  this.pageNo++;
  this.getMsgList(this.slideIndex);

  setTimeout(() => {
    refresher.complete();
  }, 1000);
 }

}



// WEBPACK FOOTER //
// ./src/pages/message/wddbmsglist/wddbmsglist.ts